// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-box[data-v-28c7d3b3]{border-top:6px solid #f6f7f9}.title-tips[data-v-28c7d3b3]{height:38px;line-height:38px;color:#999;font-size:12px}.title-bar[data-v-28c7d3b3]{padding:20px 0 0 15px;color:#333;font-size:14px;font-family:PingFang SC-Regular,PingFang SC;font-weight:400;position:relative}", ""]);
// Exports
module.exports = exports;
